export const UNSAVED_FORM_WARNING = 'You have unsaved changes, are you sure you want to leave?'
